export const Roles = {
    TRAVELER : 'Traveler',
    AGENCY_USER : 'Primary Contact',
    AGENCY_USER_SC : 'Sales Consultant',
    AGENCY_MANAGER : 'Agency Manager',
    AGENCY_USER_U : 'User',
    PHOTO_ADMIN: 'Photo Admin',
    ADMIN : 'admin'
}
